import { Injectable } from '@angular/core';
import { OfflineLoggingHandler } from '../handlers/offline-logging.handler';
import { BaseLogging } from '../../abstracts';
import { LogChannel } from '../../constants';

@Injectable({
  providedIn: 'root',
})
export class OfflineLoggingService extends BaseLogging<void, void> {
  #datadogHandler = new OfflineLoggingHandler();
  #amplitudeHandler = new OfflineLoggingHandler();
  #intercomHandler = new OfflineLoggingHandler();

  constructor() {
    super();
    this.init();
  }

  createSetup(): void {
    // No setup needed
  }

  init(): void {
    this.#datadogHandler.init(LogChannel.Datadog);
    this.#amplitudeHandler.init(LogChannel.Amplitude);
    this.#intercomHandler.init(LogChannel.Intercom);
  }
}
